const Modal = require("components/modals/BaseModal");
const assign = require("object-assign");
const PropTypes = require("prop-types");
const Promise = require("es6-promise");
const {classList} = require("helpers/html");

class Confirm extends Modal {

	static get propTypes() {
		return assign(super.propTypes, {
			confirm: PropTypes.string,
			cancel: PropTypes.string,
			no_styles: PropTypes.bool,
		});
	}

	static get defaultProps() {
		return assign(super.defaultProps, {
			confirm: "Ja",
			cancel: "Nej",
			closeable: false,
			defaultOpen: false,
			no_styles: false,
		});
	}

	get baseClassName() {
		return this.props.no_styles ?
			super.baseClassName :
			classList(
				super.baseClassName,
				"confirm-modal"
			);
	}

	constructor(props) {
		super(props);

		this.awaitBody = null;
		this.awaitTitle = null;
		this.resolveAwait = null;
		this.rejectAwait = null;
	}

	onCancel = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.close(true);
		this.rejectAwait();
		this.clearAwait();
	};

	onConfirm = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.close(true);
		this.resolveAwait();
		this.clearAwait();
	};

	clearAwait() {
		this.awaitBody = null;
		this.awaitTitle = null;
		this.resolveAwait = null;
		this.rejectAwait = null;
	}

	await(body = null, title = null) {
		// Update body
		this.awaitBody = body;

		// Update body
		this.awaitTitle = title;

		// Open dialog
		this.container.forceUpdate(() => {
			this.open();
		});

		// Create and return promise
		return new Promise((resolve, reject) => {
			this.resolveAwait = resolve;
			this.rejectAwait = reject;
		});
	}

	renderBody() {
		return (
			<div>
				{this.props.children}
				<h3 className="title">{this.awaitTitle ? this.awaitTitle : 'Foretag valg'}</h3>
				<div className="await-body">{this.awaitBody}</div>
			</div>
		);
	}

	renderFooter() {
		return (
			<div className="modal-footer">
				<button type="button" className="btn cancel" onClick={this.onCancel}>{this.props.cancel}</button>
				<button type="button" className="btn confirm" onClick={this.onConfirm}>{this.props.confirm}</button>
			</div>
		);
	}

}

module.exports = Confirm;



// WEBPACK FOOTER //
// ./resources/js/components/modals/Confirm.js